import isEqual from 'lodash/isEqual';
import union from 'lodash/union';

export const getChangedKeys = <T extends object>(obj1: Partial<T> = {}, obj2: Partial<T> = {}): Array<keyof T> => {
  const allKeys = union(Object.keys(obj1), Object.keys(obj2)) as Array<keyof T>;

  return allKeys.filter((key: keyof T) => {
    return !isEqual(obj1[key], obj2[key]);
  });
};
